import { useEffect, useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import get from "lodash/get";

import encryptObject from "shared/util/encryptObject";
import localStorage from "shared/util/localStorage";
import { isDesktop } from "shared/util/EnvironmentHelpers";
import { getDeviceId } from "shared/util/deviceId";
import isApp from "shared/util/isApp";

export const HAS_UPLOADED_BLOB_KEY = "HAS_UPLOADED_BLOB";

const UPLOAD_BLOB = gql`
	mutation uploadBlob($input: SessionBlobInput!) {
		sessionBlob(input: $input) {
			success
		}
	}
`;

async function createBlob(userid) {
	const {
		navigator: {
			userAgent,
			hardwareConcurrency,
			deviceMemory,
		} = {},
		screen: {
			width,
			height,
		} = {},
	} = window;
	const data = {
		user_id: userid,
		platform: isDesktop
			? "web"
			: "mobile_web",
		browser_fingerprint: `${await getDeviceId()}`,
	};

	if (userAgent) {
		data.user_agent = userAgent;
	}

	if (hardwareConcurrency) {
		data.num_cpu_cores = `${(hardwareConcurrency || 1)}`;
	}

	if (deviceMemory) {
		data.total_memory_bytes = `${(navigator.deviceMemory || 1) * 1024}`;
	}

	if (width && height) {
		data.screen_height = `${height}`;
		data.screen_width = `${width}`;
	}

	return data;
}

async function packageBlob(blob) {
	return {
		variables: {
			input: {
				blob: await encryptObject(blob),
			},
		},
	};
}

function useSessionBlobUploader(userid) {
	const [uploadBlob] = useMutation(UPLOAD_BLOB);
	const [hasUploadedBlob, setHasUploadedBlob] = useState(
		localStorage.getItem(HAS_UPLOADED_BLOB_KEY),
	);

	useEffect(() => {
		if (!userid || hasUploadedBlob || isApp()) {
			return;
		}

		setHasUploadedBlob(true);
		createBlob(userid)
			.then(packageBlob)
			.then(uploadBlob)
			.then((result) => {
				const isUploadSuccessful = get(result, "data.sessionBlob.success");

				if (isUploadSuccessful) {
					localStorage.setItem(HAS_UPLOADED_BLOB_KEY, true);
				}
			})
			.catch(() => {
				console.log("Error: Blob transmission failed.");
			});
	}, [hasUploadedBlob, uploadBlob, userid]);
}

export default useSessionBlobUploader;



// WEBPACK FOOTER //
// ./src/shared/hooks/useSessionBlobUploader.js